/**
 * Loan View API paths (relative to axios baseURL, e.g. …/api/v1).
 * `{loan}` / loanRef = numeric `loans.id` OR string `loan_number`.
 */

export const loanHistoryPath = (loanRef) =>
	`/loans/${encodeURIComponent(String(loanRef))}/history`;

export const loanCommentsPath = (loanRef) =>
	`/loans/${encodeURIComponent(String(loanRef))}/comments`;

export const loanAttachmentsPath = (loanRef) =>
	`/loans/${encodeURIComponent(String(loanRef))}/attachments`;
